import React from "react";

let counter = 0;

/**
 * Injiziert ein <script type="application/ld+json"> für die aktuelle Seite
 * und entfernt es beim Verlassen der Route wieder.
 *
 * @param {object|object[]} data  Ein oder mehrere Schema.org-Objekte.
 */
export default function useJsonLd(data) {
  const json = React.useMemo(() => JSON.stringify(data), [data]);

  React.useEffect(() => {
    if (!json || json === "null") return undefined;

    const id = `jsonld-page-${counter++}`;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = json;
    document.head.appendChild(script);

    return () => {
      document.getElementById(id)?.remove();
    };
  }, [json]);
}
